import { t } from 'i18next';
import * as yup from 'yup';

import { PlanUnitLink, PlanUnit } from '../../types';
import { HierarchyPlanUnit } from './treeHierarchy';

export const linkPlanUnitFormSchema = (mode?: PlanUnitLink) => {
  switch (mode) {
    case PlanUnitLink.REQUEST_POOL:
      return requestPoolSchema;
    case PlanUnitLink.EMPLOYEE_POOL:
      return employeePoolSchema;
    case PlanUnitLink.CLUSTER:
      return clusterSchema;
    case PlanUnitLink.EMPLOYER:
    default:
      return entitySchema;
  }
};

export const linkPlanUnitFormDefault = (
  mode: PlanUnitLink | undefined,
  row: PlanUnit | HierarchyPlanUnit
) => {
  if (!row) return {};

  switch (mode) {
    case PlanUnitLink.REQUEST_POOL:
      return {
        requestPool: row.pool
          ? {
              label: row.pool?.name,
              value: row.pool?.id.toString()
            }
          : null
      };
    case PlanUnitLink.EMPLOYEE_POOL:
      return {
        employeePool: row.empPool
          ? {
              label: row.empPool?.name,
              value: row.empPool?.id.toString()
            }
          : {}
      };
    case PlanUnitLink.EMPLOYER:
      return {
        entity:
          row.employerId && row.employerName
            ? {
                label: row.employerName,
                value: row.employerId
              }
            : {}
      };
    case PlanUnitLink.CLUSTER:
      return {
        entity:
          (row.clusters || [])?.map((cluster) => ({
            label: cluster.clusterName,
            value: cluster.clusterId
          }))?.[0] || null
      };
  }
};

const optionSchema = yup
  .object()
  .shape({
    label: yup.string(),
    value: yup.string()
  })
  .notRequired()
  .nullable();

const requestPoolSchema = yup.object().shape({
  requestPool: optionSchema
});

const employeePoolSchema = yup.object().shape({
  employeePool: optionSchema
});

const clusterSchema = yup.object({
  entity: yup
    .object()
    .shape({
      labe: yup.string(),
      value: yup.string()
    })
    .required(t('validation.valueIsRequired'))
    .typeError(t('validation.valueIsRequired'))
});

const entitySchema = yup.object({
  entity: yup
    .object()
    .shape({
      labe: yup.string(),
      value: yup.string()
    })
    .nullable()
});
